import { render } from "./ClientUsersTable.vue?vue&type=template&id=0ecdff2d"
import script from "./ClientUsersTable.vue?vue&type=script&lang=js"
export * from "./ClientUsersTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__